import React from 'react';
import { useLanguage } from '../../i18n';

const ProgressBar = ({ currentStep }) => {
  const { t } = useLanguage();
  const labels = {
    1: t('stepPLZ'),
    2: t('stepProject'),
    3: t('stepDemand'),
    4: t('stepDetails'),
    5: t('stepResult'),
    6: t('stepContact')
  };

  return (
    <div className="progress-bar">
      {[1, 2, 3, 4, 5, 6].map(step => (
        <div key={step} className="progress-step">
          <div 
            className={`progress-circle ${currentStep === step ? 'active' : ''} ${currentStep > step ? 'completed' : ''}`}
          >
            {step}
          </div>
          <span className="progress-label">
            {labels[step]}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
